import React from 'react';
import { Box, Typography } from '@mui/material';
import { UserProviderChip } from './UserProviderChip';

interface UpdatedByCellProps {
  updatedAt?: string | null;
  providerId?: string | null;
  displayNames: Record<string, string>;
  namesLoading?: boolean;
}

/** Updated timestamp with editor initials; tooltip shows full name only. */
export const UpdatedByCell: React.FC<UpdatedByCellProps> = ({
  updatedAt,
  providerId,
  displayNames,
  namesLoading = false,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      <Typography variant="body2" component="span" sx={{ whiteSpace: 'nowrap' }}>
        {updatedAt ? new Date(updatedAt).toLocaleDateString() : '—'}
      </Typography>
      <UserProviderChip
        providerId={providerId}
        displayNames={displayNames}
        namesLoading={namesLoading}
      />
    </Box>
  );
};

export default UpdatedByCell;
